<!-- Templates -->
<ng-template #cardBlock let-data>
  <div class="card-container">
    <mat-card class="mat-card full blue">
      <mat-card-content>
        {{ data.dates }}
      </mat-card-content>
    </mat-card>

    <mat-card class="mat-card">
      <mat-card-title>Incidents</mat-card-title>
      <mat-card-content (click)="redirectToIncidentsPageWithFilters(data.timePeriod)" class="incidents-count-link">{{
        data.incidentsCount
      }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card">
      <mat-card-title>Affected entities</mat-card-title>
      <mat-card-content>{{ data.affectedEntitiesCount }}</mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!-- End templates -->

<section>
  <div class="section-header">
    <h1 class="title">Analytics dashboard</h1>
  </div>
  <div class="filters">
    <form #filtersForm="ngForm" [formGroup]="filterGroup">
      <div class="grid-cell">
        <div class="timedate-group grid-tile" [formGroup]="$any(filterGroup.controls['timeperiod1'])">
          <div class="label-container">
            <label for="timeperiod1">Timedate 1</label>
          </div>
          <div class="row">
            <mat-form-field class="form-field" appearance="fill">
              <input
                matInput
                [matDatepicker]="picker1"
                (focus)="picker1.open()"
                formControlName="dateStart"
                placeholder="Select start date"
                [readonly]="true"
              />
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker
                #picker1
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, picker1, 'timeperiod1.dateStart')"
                startView="multi-year"
              ></mat-datepicker>
            </mat-form-field>

            <span class="to-text">to:</span>

            <mat-form-field class="form-field" appearance="fill">
              <input
                matInput
                [matDatepicker]="picker2"
                (focus)="picker2.open()"
                formControlName="dateEnd"
                placeholder="Select end date"
                [readonly]="true"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker
                #picker2
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, picker2, 'timeperiod1.dateEnd')"
                startView="multi-year"
              ></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="grid-cell">
        <div class="timedate-group grid-tile" [formGroup]="$any(filterGroup.controls['timeperiod2'])">
          <div class="label-container">
            <label for="timeperiod2">Timedate 2</label>
          </div>
          <div class="row">
            <mat-form-field class="form-field" appearance="fill">
              <input
                matInput
                [matDatepicker]="picker3"
                (focus)="picker3.open()"
                formControlName="dateStart"
                placeholder="Select start date"
                [readonly]="true"
              />
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker
                #picker3
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, picker3, 'timeperiod2.dateStart')"
                panelClass="month-picker"
              ></mat-datepicker>
            </mat-form-field>

            <span class="to-text">to:</span>

            <mat-form-field class="form-field" appearance="fill">
              <input
                matInput
                [matDatepicker]="picker4"
                (focus)="picker4.open()"
                formControlName="dateEnd"
                placeholder="Select end date"
                [readonly]="true"
              />
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker
                #picker4
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, picker4, 'timeperiod2.dateEnd')"
                panelClass="month-picker"
              ></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="grid-cell">
        <div class="timedate-group grid-tile">
          <app-geo-location-selector [countryCodesControl]="countryCodesControl" />
        </div>
      </div>

      <div class="grid-cell">
        <div class="timedate-group grid-tile" [formGroup]="$any(filterGroup.controls['revenue'])">
          <div class="label-container">
            <label for="revenue">Revenue</label>
          </div>
          <div class="row">
            <mat-form-field class="form-field" appearance="fill">
              <input matInput placeholder="Enter number" formControlName="start" type="text" inputmode="decimal" />
              <mat-error [appDecimalError]="$any(filterGroup.controls['revenue']).get('start')"></mat-error>
            </mat-form-field>

            <span class="to-text">to:</span>

            <mat-form-field class="form-field" appearance="fill">
              <input matInput placeholder="Enter number" formControlName="end" type="text" inputmode="decimal" />
              <mat-error [appDecimalError]="$any(filterGroup.controls['revenue']).get('end')"></mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="grid-cell">
        <div class="timedate-group grid-tile">
          <div class="label-container">
            <label for="companySize">Entity Size</label>
          </div>
          <div class="row">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>Pick one or more entity sizes</mat-label>
              <mat-select formControlName="entitySizes" multiple>
                <!-- Company size sectors -->
                @for (option of entitySizeOptions; track $index) {
                  <mat-option
                    class="tree-selectable"
                    [matTooltip]="entityTooltipDescriptor[option.value]"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="grid-cell">
        <div class="timedate-group grid-tile">
          <div class="label-container">
            <label for="businessSectors">Business sectors</label>
          </div>
          <div class="row">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>Pick one or more business sectors</mat-label>
              <mat-select formControlName="businessSectors" multiple>
                @for (option of businessSectorOptions; track $index) {
                  <mat-option class="tree-selectable" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
              @if (filterHasValue('businessSectors')) {
                <button
                  class="filter-clear-btn"
                  mat-icon-button
                  matSuffix
                  aria-label="Clear selection"
                  (click)="clearIndividualFilter($event, 'businessSectors')"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="search">
      <button
        class="search"
        mat-flat-button
        [disabled]="filterButtonDisabled"
        color="primary"
        (click)="updateFilters(filtersForm)"
      >
        Search
      </button>
      <button class="clear" mat-flat-button color="secondary" (click)="clearFilters()">Clear</button>
    </div>
  </div>

  <div class="info-cards">
    @if (analytics && analytics.analyticsPeriodA) {
      <ng-container
        *ngTemplateOutlet="
          cardBlock;
          context: {
            $implicit: {
              dates: uiTimeRangeA.dates,
              timePeriod: uiTimeRangeA.timePeriod,
              incidentsCount: analytics.analyticsPeriodA.incidentsCount,
              affectedEntitiesCount: analytics.analyticsPeriodA.affectedEntitiesCount,
            },
          }
        "
      ></ng-container>
    }

    @if (analytics && analytics.analyticsPeriodB) {
      <ng-container
        *ngTemplateOutlet="
          cardBlock;
          context: {
            $implicit: {
              dates: uiTimeRangeB.dates,
              timePeriod: uiTimeRangeB.timePeriod,
              incidentsCount: analytics.analyticsPeriodB.incidentsCount,
              affectedEntitiesCount: analytics.analyticsPeriodB.affectedEntitiesCount,
            },
          }
        "
      ></ng-container>
    }
  </div>

  @if (!!dataSource.data.length) {
    <div class="analytics-summary">
      <div class="analytics-view-mode">
        <span>View by:</span>
        <mat-chip-listbox (change)="onTableViewChange($event)">
          <mat-chip-option
            [selected]="viewTable === 'entity'"
            (selectionChange)="onChipSelectionChange($event)"
            value="entity"
            >Business sector</mat-chip-option
          >
          <mat-chip-option
            [selected]="viewTable === 'country'"
            (selectionChange)="onChipSelectionChange($event)"
            value="country"
            >Country</mat-chip-option
          >
          <mat-chip-option
            [selected]="viewTable === 'continent'"
            (selectionChange)="onChipSelectionChange($event)"
            value="continent"
            >Continent</mat-chip-option
          >
        </mat-chip-listbox>
      </div>

      @switch (viewTable) {
        @case ('entity') {
          <table mat-table [dataSource]="dataSource" matSort #entitySort="matSort" class="mat-elevation-z8">
            <!-- Business sectors Column -->
            <ng-container matColumnDef="businessSectorLabel">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Business sectors</th>
              <td mat-cell *matCellDef="let element">
                {{ element.businessSectorLabel }}
              </td>
            </ng-container>

            <!-- Timeperiod A Column -->
            <ng-container matColumnDef="incidentCountA">
              <th class="time-range" mat-header-cell mat-sort-header *matHeaderCellDef>
                <p class="text-center">
                  Incidents in <br />
                  <span class="small-th">{{ uiTimeRangeA.dates }}</span>
                </p>
              </th>
              <td
                class="time-range text-center incidents-count-table-view-link"
                mat-cell
                *matCellDef="let element"
                (click)="redirectToIncidentsPageFromBusinessSectorView(element.businessSector, 'A')"
              >
                {{ element.incidentCountA }}
              </td>
            </ng-container>

            <!-- Timeperiod B Column -->
            <ng-container matColumnDef="incidentCountB">
              <th class="time-range text-center" mat-header-cell mat-sort-header *matHeaderCellDef>
                <p class="text-center">
                  Incidents in <br />
                  <span class="small-th">{{ uiTimeRangeB.dates }}</span>
                </p>
              </th>
              <td
                class="time-range text-center incidents-count-table-view-link"
                mat-cell
                *matCellDef="let element"
                (click)="redirectToIncidentsPageFromBusinessSectorView(element.businessSector, 'B')"
              >
                {{ element.incidentCountB }}
              </td>
            </ng-container>

            <!-- Increase/Decrease -->
            <ng-container matColumnDef="ratioNumeric">
              <th class="text-center" mat-header-cell mat-sort-header *matHeaderCellDef>Increase / Decrease</th>
              <td class="text-center" mat-cell *matCellDef="let element">
                {{ element.ratioNumeric }}
              </td>
            </ng-container>

            <!-- Comparison -->
            <ng-container matColumnDef="ratioProgress">
              <th class="trend" mat-header-cell mat-sort-header *matHeaderCellDef>Trend</th>
              <td class="trend" mat-cell *matCellDef="let element">
                <mat-progress-bar
                  mode="determinate"
                  [ngClass]="'bar-' + element.trend"
                  [value]="element.ratioProgress || 50"
                ></mat-progress-bar>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="analyticsEntityTableColumns"></tr>
            <tr
              [ngClass]="{ 'disabled-row': row.status === IncidentStatus.Disabled }"
              ngClass="table-row"
              mat-row
              *matRowDef="let row; columns: analyticsEntityTableColumns"
            ></tr>
          </table>
        }
        @case ('country') {
          <table mat-table [dataSource]="dataSource" matSort #countrySort="matSort" class="mat-elevation-z8">
            <!-- Country Column -->
            <ng-container matColumnDef="countryLabel">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Country</th>
              <td mat-cell *matCellDef="let element">{{ element.countryLabel }}</td>
            </ng-container>

            <!-- Timeperiod A Column -->
            <ng-container matColumnDef="incidentCountA">
              <th class="time-range text-center" mat-header-cell mat-sort-header *matHeaderCellDef>
                Incidents in <br />
                {{ uiTimeRangeA.dates }}
              </th>
              <td
                class="time-range text-center incidents-count-table-view-link"
                mat-cell
                *matCellDef="let element"
                (click)="redirectToIncidentsPageFromCountryView(element.country, 'A')"
              >
                {{ element.incidentCountA }}
              </td>
            </ng-container>

            <!-- Timeperiod B Column -->
            <ng-container matColumnDef="incidentCountB">
              <th class="time-range text-center" mat-header-cell mat-sort-header *matHeaderCellDef>
                Incidents in <br />
                {{ uiTimeRangeB.dates }}
              </th>
              <td
                class="time-range text-center incidents-count-table-view-link"
                mat-cell
                *matCellDef="let element"
                (click)="redirectToIncidentsPageFromCountryView(element.country, 'B')"
              >
                {{ element.incidentCountB }}
              </td>
            </ng-container>

            <!-- Increase/Decrease -->
            <ng-container matColumnDef="ratioNumeric">
              <th class="text-center" mat-header-cell mat-sort-header *matHeaderCellDef>Increase / Decrease</th>
              <td class="text-center" mat-cell *matCellDef="let element">
                {{ element.ratioNumeric }}
              </td>
            </ng-container>

            <!-- Comparison -->
            <ng-container matColumnDef="ratioProgress">
              <th class="trend" mat-header-cell mat-sort-header *matHeaderCellDef>Trend</th>
              <td class="trend" mat-cell *matCellDef="let element">
                <mat-progress-bar
                  mode="determinate"
                  [ngClass]="'bar-' + element.trend"
                  [value]="element.ratioProgress || 50"
                ></mat-progress-bar>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="analyticsCountryTableColumns"></tr>
            <tr
              [ngClass]="{ 'disabled-row': row.status === IncidentStatus.Disabled }"
              ngClass="table-row"
              mat-row
              *matRowDef="let row; columns: analyticsCountryTableColumns"
            ></tr>
          </table>
        }
        @case ('continent') {
          <table mat-table [dataSource]="dataSource" matSort #continentSort="matSort" class="mat-elevation-z8">
            <!-- Continent Column -->
            <ng-container matColumnDef="continentLabel">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Continent</th>
              <td mat-cell *matCellDef="let element">
                {{ element.continentLabel }}
              </td>
            </ng-container>

            <!-- Timeperiod A Column -->
            <ng-container matColumnDef="incidentCountA">
              <th class="time-range text-center" mat-header-cell mat-sort-header *matHeaderCellDef>
                Incidents in <br />
                {{ uiTimeRangeA.dates }}
              </th>
              <td
                class="time-range text-center incidents-count-table-view-link"
                mat-cell
                *matCellDef="let element"
                (click)="redirectToIncidentsPageFromContinentView(element.continent, 'A')"
              >
                {{ element.incidentCountA }}
              </td>
            </ng-container>

            <!-- Timeperiod B Column -->
            <ng-container matColumnDef="incidentCountB">
              <th class="time-range text-center" mat-header-cell mat-sort-header *matHeaderCellDef>
                Incidents in <br />
                {{ uiTimeRangeB.dates }}
              </th>
              <td
                class="time-range text-center incidents-count-table-view-link"
                mat-cell
                *matCellDef="let element"
                (click)="redirectToIncidentsPageFromContinentView(element.continent, 'B')"
              >
                {{ element.incidentCountB }}
              </td>
            </ng-container>

            <!-- Increase/Decrease -->
            <ng-container matColumnDef="ratioNumeric">
              <th class="text-center" mat-header-cell mat-sort-header *matHeaderCellDef>Increase / Decrease</th>
              <td class="text-center" mat-cell *matCellDef="let element">
                {{ element.ratioNumeric }}
              </td>
            </ng-container>

            <!-- Comparison -->
            <ng-container matColumnDef="ratioProgress">
              <th class="trend" mat-header-cell mat-sort-header *matHeaderCellDef>Trend</th>
              <td class="trend" mat-cell *matCellDef="let element">
                <mat-progress-bar
                  mode="determinate"
                  [ngClass]="'bar-' + element.trend"
                  [value]="element.ratioProgress || 50"
                ></mat-progress-bar>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="analyticsContinentTableColumns"></tr>
            <tr
              [ngClass]="{ 'disabled-row': row.status === IncidentStatus.Disabled }"
              ngClass="table-row"
              mat-row
              *matRowDef="let row; columns: analyticsContinentTableColumns"
            ></tr>
          </table>
        }
      }

      @if (totalEntries >= pageSize) {
        <mat-paginator
          [length]="totalEntries"
          [pageSize]="pageSize"
          [pageIndex]="pageNumber"
          [pageSizeOptions]="[]"
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      }
    </div>
  }
</section>
